export const youtube = "https://www.youtube.com/channel/UCEU0DruXZt_QPOLzNTIBiPQ";
export const instagram = "https://www.instagram.com/WhiteCollarBlueAU/";
export const twitter = "https://twitter.com/WhiteCollarBlu?lang=en";
export const facebook = "https://www.facebook.com/WhiteCollarBlue/";
export const linkedin = "https://www.linkedin.com/company/whitecollarblue-pty-ltd/";
export const tiktok = "https://www.tiktok.com/@whitecollarblue";
